import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {AuthenticationService} from '@services/authentification.service';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    constructor(
        private router: Router,
        public authenticationService: AuthenticationService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        // Attendre que le profil soit chargé (sinon pro_plan est vide juste après un F5)
        return this.authenticationService.userLoaded$.pipe(
            filter(loaded => loaded),
            take(1),
            map(() => {
                if (this.authenticationService.isLogin && this.authenticationService.currentUser.pro_plan == 'lybox') {
                    // administrateur LyBox : accès autorisé
                    return true;
                }

                if (!this.authenticationService.isLogin) {
                    // pas connecté : redirection vers la page de login
                    this.router.navigate(['/app/login'], {queryParams: {returnUrl: state.url}});
                    return false;
                }

                // connecté mais pas administrateur : redirection vers l'accueil
                this.router.navigate(['/app/search/result']);
                return false;
            })
        );
    }
}
